<template>
  <v-form
    ref="itemsform"
    lazy-validation
  >
    <v-text-field
      v-model="editedItem.name"
      label="Permission Name"
      outlined
      :rules="[rules.required]"
    />
    <v-text-field
      v-model="editedItem.description"
      label="Description"
      outlined
      :rules="[rules.required]"
    />
    <v-text-field
      v-model="editedItem.title"
      label="Title"
      outlined
      :rules="[rules.required]"
    />
  </v-form>
</template>
<script>
  export default {
    name: 'permissionlevelsForm',
    props: {
      editedItem: Object
    },
    data () {
      return {
        rules: {
          required: value => !!value || 'Required.',
        },
      }
    },
  }
</script>